import { useDeleteClient } from "./useDeleteClient";
import styles from "./DeleteClientModal.module.css";

function Modal({ closeModal }) {
  const {
    selectedClient,
    deleteClientById
  } = useDeleteClient(closeModal);

  if (!selectedClient) return null;
  return (
    <div className={styles.modalBackground}>
      <div className={styles.modalContainer}>
        <div className={styles.content}>
          <h1>Deseja excluir o cliente selecionado?</h1>
          <p>{"Id: " + selectedClient.id}</p>
          <p>{"Code: " + selectedClient.code}</p>
          <p>{"Nome do cliente: " + selectedClient.name}</p>
          <p>{"CNPJ: " + selectedClient.cnpj}</p>
          <p>{"Email: " + selectedClient.email}</p>
          <p>{"Telefone: " + selectedClient.phone}</p>
        </div>

        <div className={styles.buttonContent}>
          <button
            className={styles.buttonConfirm}
            onClick={deleteClientById}>
            Deletar Cliente
          </button>

          <button
            onClick={closeModal}
            className={styles.buttonCancel}>
            Cancelar
          </button>
        </div>

      </div>
    </div>
  );
}

export default Modal;